import { Add as AddIcon } from '@mui/icons-material';
import { Box, Button } from '@mui/joy';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { ShipmentTable } from '@/components/Pages/Shipments/ShipmentTable';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/shipments/')({
  component: ShipmentsPage,
});

function ShipmentsPage() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const router = useRouter();

  const showActions = isAdmin || isSuperAdmin;

  const handleCreateShipment = () => {
    router.navigate({ to: '/shipments/create' });
  };

  return (
    <Box>
      {showActions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <Button startDecorator={<AddIcon />} onClick={handleCreateShipment}>
            Crear envío
          </Button>
        </Box>
      )}
      <ShipmentTable />
    </Box>
  );
}
